<section class="navMaker p-5" style="text-align: center;">
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Suppliers</a>
            <a class="nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-Customer" role="tab" aria-controls="nav-profile" aria-selected="false">Customers</a>
            <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Store</a>
            <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-sales" role="tab" aria-controls="nav-contact" aria-selected="false">Sales</a>
            <a class="nav-link" id="nav-admin-tab" data-toggle="tab" href="#nav-admin" role="tab" aria-controls="nav-contact" aria-selected="false">Admin</a>
        </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <!-- !!!: Supplier -->
        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <form class="p-3">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Company : </label>
                    <div class="col-6 lastU09">
                        <select [(ngModel)]='searchsupplierAdmin' name='searchsupplierAdmin' class="form-control select2 searchsupplierAdmin">
                          <option disabled>Search By Company</option>
                          <option>All</option>
                          <option *ngFor='let w of supplierA' [value]="w.id">Name : {{w.name}} || code : {{w.id}}</option>
              </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Pi No : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mb-2 select2 selectpinAdmin" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option value="undefined" disabled selected>PI NO</option>
                        <option>All</option>
                        <option *ngFor='let w of piAdmin; let e = index' [value]="e+1">{{e+1}}</option>
                </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Country : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control select2 searchsupplierCountry">
                        <option disabled selected>Search By Country</option>
                        <option>All</option>
                        <option *ngFor='let w of supplierA|noRepeat' [value]="w.adress">{{w.adress}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromSu' type="date" class="form-control fromDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToSu' type="date" class="form-control toDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <div class="col-6">
                        <button type="submit" class="btn btn-primary">Sign in</button>
                    </div>
                </div> -->
            </form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1("Period")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;cursor: pointer;">Company Sales In Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1("Items1")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Country Coming Items</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1("Items2")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Company Coming Items</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1("In")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Company Items ( In / Out )</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- !!!: Customer -->

        <div class="tab-pane fade" id="nav-Customer" role="tabpanel" aria-labelledby="nav-profile-tab">
            <form class="p-3">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Customer</label>
                    <div class="col-6 lastU09">
                        <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN" style="height: unset !important;">
                    <option value="undefined" disabled selected>Customer</option>
                    <option value="All">All</option>
                    <option *ngFor='let r of arreCustomer' [value]="r.id">{{r.name}}</option>
                  </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromCustomer' type="date" class="form-control fromDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToCustomer' type="date" class="form-control toDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                <div class="col-6">
                    <button type="submit" class="btn btn-primary">Sign in</button>
                </div>
            </div> -->
            </form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-3"></div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showCustomer("Customer")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;cursor: pointer;">Customer Payments In Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showCustomer("Customer")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Print Mailing Details</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3"></div>
                </div>
            </div>
        </div>


        <!-- !!!: Sales -->
        <div class="tab-pane fade" id="nav-sales" role="tabpanel" aria-labelledby="nav-profile-tab">
            <form class="p-3">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Quotation No : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control select2 select2QAll0" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                    <option value='undefined' disabled selected>Quotation No</option>
                    <option value='All'>All</option>
                    <option *ngFor='let x of areeAllSales|customerId:yarbs' [value]="x.id">{{x.id}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Hold Quotation : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control select2 select2QAll" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                    <option value='undefined' disabled selected>Hold Quotation</option>
                    <option value='All'>All</option>
                    <option *ngFor='let x of areeAllStore|customerId:yarbs' [value]="x.id">{{x.id}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Invoice No : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control select2 select2Q" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option value='undefined' disabled selected>Invoice No</option>
                        <option value='All'>All</option>
                        <option *ngFor='let x of arreNo00|customerId:yarbs' [value]="x.id">{{x.id}}</option>
                </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Category : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mb-2 select2 selectpin0" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option value="undefined" disabled selected>Category</option>
                        <option>All</option>
                        <option *ngFor='let w of allCa;' [value]="w.id">{{w.name}}</option>
                </select>
                    </div>
                </div>
                <!-- <div class="form-group row">
                <label for="inputEmail3" class="col-4 col-form-label">Pi No : </label>
                <div class="col-6 lastU09">
                    <select class="form-control mb-2 select2 selectpin" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                    <option value="undefined" disabled selected>PI NO</option>
                    <option>All</option>
                    <option *ngFor='let w of pi; let e = index' [value]="e+1">{{e+1}}</option>
            </select>
                </div>
            </div> -->
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Area : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mt-4 sO submitNumber select2 areaSelect" style="height: unset !important;">
                        <option selected disabled>Search By Area</option>
                        <option value="All">All</option>
                        <option *ngFor='let r of arreCustomer|noRepeatArea' [value]="r.area">{{r.area}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Payment Method : </label>
                    <div class="col-6">
                        <select class="form-control">
                        <option value='undefined' disabled selected>Payment Method</option>
                        <option value='Cash'>Cash</option>
                        <option value='Visa'>Visa</option>
                        <option value='Check'>Check</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFrom' type="date" class="form-control fromDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateTo' type="date" class="form-control toDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                <div class="col-6">
                    <button type="submit" class="btn btn-primary">Sign in</button>
                </div>
            </div> -->
            </form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("goSalesAll00")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;cursor: pointer;">Show Quotation</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("ShowQuotation00")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Show Hold Quotation</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("ShowQuotation")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Show Order Invoice</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("salesInvoice1")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Area Payments In Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("goSalesInvoiceCategory")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Category Sales In Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='goSalesInvoice("salesInvoiceAll")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Total Payments In Period</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">

            <!-- !!!: Store  -->


            <form class="p-3">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Store</label>
                    <div class="col-6 lastU09">
                        <select class="form-control mb-2 select2 placeSearchStore" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option disabled selected>Search By Store</option>
                        <input type='text'>
                        <option>All</option>
                        <option *ngFor='let w of rootA' [value]="w.id">{{w.name}}</option>
                </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Item Code : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mb-2 select2 serchCodeStore" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option disabled selected value="undefined">Search By Code</option>
                        <option>All</option>
                        <option *ngFor='let w of arre' [value]="w.code">{{w.code}}</option>
                      </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSu' [(ngModel)]='dateFromStore' type="date" class="form-control fromDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSu' [(ngModel)]='dateToStore' type="date" class="form-control toDA" (change)='pipeFilter()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                <div class="col-6">
                    <button type="submit" class="btn btn-primary">Sign in</button>
                </div>
            </div> -->
            </form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Store("StorePeriod")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;cursor: pointer;">Available Items In Store Come In <br>Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Store("goStoreInvoice")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Item In / Out In <br>Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Store("goStoreInvoice2")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Item Payments In <br>Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Store("All Items")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Show All Items In Store / <br>Showroom</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>


        <!-- !!!: Admin -->
        <div class="tab-pane fade show" id="nav-admin" role="tabpanel" aria-labelledby="nav-home-tab">
            <form class="p-3">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Company : </label>
                    <div class="col-6 lastU09">
                        <select [(ngModel)]='searchsupplierAdmin1' name='searchsupplierAdmin1' class="form-control select2 searchsupplierAdmin1" id="exampleFormControlSelect1">
                        <option disabled>Search By Company</option>
                        <option>All</option>
                        <option *ngFor='let w of supplierA' [value]="w.id">Name : {{w.name}} || code : {{w.id}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Pi No : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control mb-2 select2 selectpinAdmin1" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                      <option value="undefined" disabled selected>PI NO</option>
                      <option>All</option>
                      <option *ngFor='let w of piAdmin1; let e = index' [value]="e+1">{{e+1}}</option>
              </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">Country : </label>
                    <div class="col-6 lastU09">
                        <select class="form-control select2 searchsupplierCountry1">
                        <option disabled selected>Search By Country</option>
                        <option>All</option>
                        <option *ngFor='let w of supplierA|noRepeat' [value]="w.adress">{{w.adress}}</option>
            </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-4 col-form-label">From Date : </label>
                    <div class="col-6">
                        <input name='dateFromSuAdmin' [(ngModel)]='dateFromSuAdmin' type="date" class="form-control fromDA" (change)='pipeFilterAdmin()'>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-4 col-form-label">To Date : </label>
                    <div class="col-6">
                        <input name='dateToSuAdmin' [(ngModel)]='dateToSuAdmin' type="date" class="form-control toDA" (change)='pipeFilterAdmin()'>
                    </div>
                </div>
                <!-- <div class="form-group row">
                  <div class="col-6">
                      <button type="submit" class="btn btn-primary">Sign in</button>
                  </div>
              </div> -->
            </form>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Admin("goSupplierinvoiceAdmin")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;cursor: pointer;">Company Sales In Period</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Admin2("Items1")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Country Coming Items</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Admin2("Items2")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Company Coming Items</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Admin2("In")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Company Items ( In / Out )</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li (click)='showSupplier1Admin("goStoreAdmin")' class="list-group-item py-4" style="font-weight: bolder;border: 1px black solid;">Company Remaining Items</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
<section id="updPho" style="text-align: center !important;">
    <button (click)='closePhot()' type="button" class="btn btn-danger m-4" style="box-shadow: none;display: inline;position: fixed;top: 0;left:0;z-index: 20000 !important;"><i class="fas fa-times " style="color: white; cursor: pointer;"></i></button>
    <div style="text-align: center !important; overflow: hidden !important;width: 100%;height: 100%;">
        <div style="display: inline-block; overflow: hidden !important;width: 100%;height: 100%;" id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" *ngIf='qwss' style="height: 100%;width: 100%;">
                <div class="carousel-item active" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[0].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
                <div *ngFor='let f of arrImage|slice:1; let ff = index;' class="carousel-item" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[ff + 1].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
            </div>
            <a style="margin:auto;margin-left:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-prev shadow-lg" href="#carouselExampleControls" role="button" data-slide="prev">
                <span style="margin-top: 25%;" class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a style="margin:auto;margin-right:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-next shadow-lg" href="#carouselExampleControls" role="button" data-slide="next">
                <span style="margin-top: 25%;" class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</section>

<!-- !!!: Supplier Table -->

<div class="col-12 goSupplier">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNew()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Company : {{nameSubPri}}   </span><span class='country'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Country : {{searchsupplierCountry}} </span> <span class='supplier2'> Sales : {{sumSales}} </span>
            </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Company</th>
                                    <th scope="col">PI.NO</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Item_Code</th>
                                    <!-- <th scope="col">Order Date</th>
          <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Description</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Qty</th>
                                    <!-- <th scope="col">Dimensions</th>
            <th scope="col">Finishing/fabrics</th>
             -->
                                    <th scope="col">In</th>
                                    <th scope="col">Out</th>
                                    <th scope="col">Reseved</th>
                                    <th scope="col">Available</th>
                                    <th scope="col">Defect</th>
                                    <th scope="col">Sales</th>
                                    <th scope="col">Notes</th>
                                    <!-- <th scope="col">Branch</th>
            <th scope="col">Price</th>
            <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
            <th scope="col" class='no' *ngIf='delete'>Delete</th>
            <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|categorySearch:categorySearch|serchCode:serchCode|placeSearch:placeSearch|searchSupplier:searchsupplierAdmin|selectpin:selectpinAdmin|dateCom:dateFromSu:dateToSu|countrySearch:searchsupplierCountry; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Company">{{v.suppliername}}</td>
                                    <td data-title="PI NO">{{v.pino}}</td>
                                    <td data-title="Date">{{v.datereceipt|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Item_Code">{{v.code}}</td>
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Category">{{v.categoryname}}</td>
                                    <td data-title="Qty">{{v.qty}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
          <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
            <td data-title="Finishing/fabrics">{{v.fabric}}</td>
             -->
                                    <td data-title="In">{{v.mainqty}}</td>
                                    <td data-title="Out">{{v.qtyfinish}}</td>
                                    <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <td data-title="Defect">{{v.defect}}</td>
                                    <td data-title="Sales">{{v.sales}}</td>
                                    <td data-title="Notes">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                    </td>
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
            <td data-title="Price">{{v.price}}</td>
            <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
            <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
            </td>
            <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
            </td> -->
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style="text-align: center;"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col">{{sumIn}}</th>
                                    <th scope="col">{{sumOut}}</th>
                                    <th scope="col"></th>
                                    <th scope="col">{{sumAvaliable}}</th>

                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <!-- <th scope="col"></th> -->
                                    <!-- <th scope="col">Update</th> -->
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>

<!-- !!!: Supplier Table Admin -->

<div class="col-12 goSupplierAdmin2">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNew()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Company : {{nameSubPri1}}   </span><span class='country'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Country : {{searchsupplierCountry1}} </span> <span class='supplierDir'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>                <span class='supplier2'> Sales : {{sumSales1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier2a'>Total In : {{sumIn1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>                <span class='supplier2b'>Total Out : {{sumOut1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier2c'>Total Available : {{sumAvaliable1}}</span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Company</th>
                                    <th scope="col">PI.NO</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Item_Code</th>
                                    <!-- <th scope="col">Order Date</th>
        <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Description</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Qty</th>
                                    <!-- <th scope="col">Dimensions</th>
          <th scope="col">Finishing/fabrics</th>
           -->
                                    <th scope="col">In</th>
                                    <th scope="col">Out</th>
                                    <th scope="col">Reseved</th>
                                    <th scope="col">Available</th>
                                    <th scope="col">Defect</th>
                                    <th scope="col">Sales</th>
                                    <th scope="col">Notes</th>
                                    <!-- <th scope="col">Branch</th>
          <th scope="col">Price</th>
          <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
          <th scope="col" class='no' *ngIf='delete'>Delete</th>
          <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|categorySearch:categorySearch|serchCode:serchCodeStore|placeSearch:placeSearchStore|searchSupplier:searchsupplierAdmin1|selectpin:selectpinAdmin1|dateCom:dateFromSuAdmin:dateToSuAdmin|countrySearch:searchsupplierCountry1; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Company">{{v.suppliername}}</td>
                                    <td data-title="PI NO">{{v.pino}}</td>
                                    <td data-title="Date">{{v.datereceipt|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Item_Code">{{v.code}}</td>
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Category">{{v.categoryname}}</td>
                                    <td data-title="Qty">{{v.qty}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
        <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
          <td data-title="Finishing/fabrics">{{v.fabric}}</td>
           -->
                                    <td data-title="In">{{v.mainqty}}</td>
                                    <td data-title="Out">{{v.qtyfinish}}</td>
                                    <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <td data-title="Defect">{{v.defect}}</td>
                                    <td data-title="Sales">{{v.sales}}</td>
                                    <td data-title="Notes">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                    </td>
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
          <td data-title="Price">{{v.price}}</td>
          <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
          <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
          </td>
          <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
          </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>
<!-- !!!: Admin Table -->
<div class="col-12 goSupplierAdmin">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNewAdmin()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;">Company : {{nameSubPri}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sales : {{sumSales}}</h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 75vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Order Date</th>
        <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Description</th>
                                    <!-- <th scope="col">Dimensions</th>
          <th scope="col">Finishing/fabrics</th>
          <th scope="col">Category</th> -->
                                    <th scope="col">In</th>
                                    <th scope="col">Out</th>
                                    <th scope="col">Reseved</th>
                                    <th scope="col">Available</th>
                                    <th scope="col">Defect</th>
                                    <th scope="col">Sales</th>
                                    <th scope="col">Notes</th>
                                    <!-- <th scope="col">Branch</th>
          <th scope="col">Price</th>
          <th scope="col">Supplier</th>
          <th scope="col">PI.NO</th>
          <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
          <th scope="col" class='no' *ngIf='delete'>Delete</th>
          <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|categorySearch:categorySearch|serchCode:serchCode|placeSearch:placeSearch|searchSupplier:searchsupplierAdmin|selectpin:selectpinAdmin|dateCom:dateFromSuAdmin:dateToSuAdmin; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
        <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
          <td data-title="Finishing/fabrics">{{v.fabric}}</td>
          <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="In">{{v.mainqty}}</td>
                                    <td data-title="Out">{{v.qtyfinish}}</td>
                                    <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <td data-title="Defect">{{v.defect}}</td>
                                    <td data-title="Sales">{{v.sales}}</td>
                                    <td data-title="Notes">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                    </td>
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
          <td data-title="Price">{{v.price}}</td>
          <td data-title="Supplier">{{v.suppliername}}</td>
          <td data-title="PI NO">{{v.pino}}</td>
          <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
          <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
          </td>
          <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
          </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<!-- !!!: Store Table -->


<div class="col-12 goStore">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Store : {{nameStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Location : {{locationStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; City : {{cityStore}} </span>                <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; From Date : {{dateFromStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To Date : {{dateToStore}} </span> <span class='TotalPrice'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Price : {{sumtotalStore1}} </span>                </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Order Date</th>
              <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Description</th>
                                    <!-- <th scope="col">Dimensions</th>
                <th scope="col">Finishing/fabrics</th>
                 -->
                                    <th scope="col">Category</th>
                                    <th scope="col">Supplier</th>
                                    <th scope="col">Unit_Price</th>
                                    <!-- <th scope="col">Reseved</th> -->
                                    <th scope="col">Qty</th>
                                    <th scope="col">Total_price</th>
                                    <th scope="col">Defect</th>
                                    <th scope="col">Sales</th>
                                    <th scope="col">Notes</th>
                                    <!-- <th scope="col">Branch</th>
                <th scope="col">Price</th>
                <th scope="col">Supplier</th>
                <th scope="col">PI.NO</th>
                <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
                <th scope="col" class='no' *ngIf='delete'>Delete</th>
                <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreStore|serchCode:serchCodeStore|placeSearch:placeSearchStore|dateCom:dateFromStore:dateToStore; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
              <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
                <td data-title="Finishing/fabrics">{{v.fabric}}</td>
                </td> -->
                                    <td data-title="Category">{{v.categoryname}}</td>
                                    <td data-title="Supplier">{{v.suppliername}}</td>
                                    <td data-title="Unit_Price">{{v.price}}</td>
                                    <!-- <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td> -->
                                    <td data-title="Qty">{{v.qty}}</td>
                                    <td data-title="Total_price">{{v.qty * v.price}}</td>
                                    <td data-title="Defect">{{v.defect}}</td>
                                    <td data-title="Sales">{{v.sales}}</td>
                                    <td data-title="Notes">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>
                                    </td>
                                    <td data-title="Date">{{v.datereceipt|date:'dd-MM-yyyy'}}</td>
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
                <td data-title="Price">{{v.price}}</td>
                <td data-title="Supplier">{{v.suppliername}}</td>
                <td data-title="PI NO">{{v.pino}}</td>
                <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!-- <td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
                </td>
                <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
                </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>








<!-- !!!: Sales Table -->


<div class="col-12 goSales">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Store : {{nameStore}} </span> <span class='store2'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sales : {{sumSales}} </span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Q.No</th>
                                    <th scope="col">Date</th>
                                    <!-- <th scope="col">Order Date</th>
            <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Money</th>
                                    <!-- <th scope="col">Dimensions</th>
              <th scope="col">Finishing/fabrics</th>
              <th scope="col">Category</th> -->
                                    <th scope="col">Payment_Method</th>
                                    <th scope="col">Image</th>
                                    <!-- <th scope="col">Unit_Price</th> -->
                                    <!-- <th scope="col">Reseved</th> -->
                                    <!-- <th scope="col">Qty</th>
                              <th scope="col">Total_price</th> -->
                                    <!-- <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
              <th scope="col">Price</th>
              <th scope="col">Supplier</th>
              <th scope="col">PI.NO</th>
              <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <!-- <th scope="col" class='no'>Photo</th>
              <th scope="col" class='no' *ngIf='update'>Update</th>
              <th scope="col" class='no' *ngIf='delete'>Delete</th>
              <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arrePayment|samedate:dateFrom:dateTo|quotationBill:yarbs000; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Q.No">{{v.bill_id}}</td>
                                    <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
            <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <td data-title="Money">{{v.money}}</td>
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
              <td data-title="Finishing/fabrics">{{v.fabric}}</td>
              <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Payment_Method">{{v.waypay}}</td>
                                    <td data-title="Image"><img style='width:50px;height:50px;cursor: pointer;' class='shadow-lg' src='{{v.image}}'></td>
                                    <!-- <td data-title="Unit_Price">{{v.price}}</td> -->
                                    <!-- <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td> -->
                                    <!-- <td data-title="Qty">{{v.qty}}</td>
                              <td data-title="Total_price">{{v.qty * v.price}}</td> -->
                                    <!-- <td data-title="Notes">{{v.notes}}</td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
              <td data-title="Price">{{v.price}}</td>
              <td data-title="Supplier">{{v.suppliername}}</td>
              <td data-title="PI NO">{{v.pino}}</td>
              <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <!-- <td data-title="Photo" class='no'>
                  <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url.url'>
              </td>
              <td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
              <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
              </td>
              <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
              </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>



<!-- !!!: Supplier Table invoice -->

<div class="col-12 goSupplierinvoice">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNew()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Company : {{nameSubPri}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='country'>Country : {{searchsupplierCountry}}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier2'>Sales : {{sumSales}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>                <span class='supplier5'>Total In : {{sumIn}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier3'> From Date : {{dateFromSu}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>                <span class='supplier4'> To Date : {{dateToSu}}  </span> <span class='supplier6'> Total Out : {{sumOut}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier7'>Total Available : {{sumAvaliable}}</span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
        <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col">Item_Code</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <!-- <th scope="col">Dimensions</th>
          <th scope="col">Finishing/fabrics</th>
          <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                                  <th scope="col">Out</th>
                                  <th scope="col">Reseved</th>
                                  <th scope="col">Available</th>
                                  <th scope="col">Defect</th>
                                  <th scope="col">Sales</th>
                                  <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
          <th scope="col">Price</th>
          <th scope="col">Supplier</th>
          <th scope="col">PI.NO</th>
          <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
          <th scope="col" class='no' *ngIf='delete'>Delete</th>
          <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|searchSupplier:searchsupplierAdmin|selectpin:selectpinAdmin|dateCom:dateFromSu:dateToSu|orderOnly|countrySearch1:searchsupplierCountry; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.id_boked}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
        <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
          <td data-title="Finishing/fabrics">{{v.fabric}}</td>
          <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Item_Code">{{v.code}}</td>
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                                  <td data-title="Sales">{{v.sales}}</td>
                                  <td data-title="Notes">
                                      <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                  </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
          <td data-title="Price">{{v.price}}</td>
          <td data-title="Supplier">{{v.suppliername}}</td>
          <td data-title="PI NO">{{v.pino}}</td>
          <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
          <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
          </td>
          <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
          </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>



<!-- !!!: Customer Table -->


<div class="col-12 goCustomer">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printCustomer()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNewCustomer()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;" *ngFor='let v of arreReportCustomer|categorySearch:categorySearch|serchCode:serchCode|placeSearch:placeSearch|searchSupplier:searchsupplier|slice: 0:1; let n = index;'>Customer : {{namePr}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; City : {{cityPr}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Adress : {{adressPr}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Total : {{sumtotalCustomer}}</h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Customer_Name</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
                <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Dimensions</th>
                  <th scope="col">Finishing/fabrics</th>
                  <th scope="col">Category</th> -->
                                    <th scope="col">Description</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Unit_Price</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Total</th>
                                    <th scope="col">Photo</th>
                                    <!-- <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
                  <th scope="col">Price</th>
                  <th scope="col">Supplier</th>
                  <th scope="col">PI.NO</th>
                  <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <!-- <th scope="col" class='no'>Photo</th>
                  <th scope="col" class='no' *ngIf='update'>Update</th>
                  <th scope="col" class='no' *ngIf='delete'>Delete</th>
                  <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|idCustomer:yarbsS|samedate:dateFromCustomer:dateToCustomer; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.customername}}</td>
                                    <td data-title="Invoice_No">{{v.id_boked}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
                <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
                  <td data-title="Finishing/fabrics">{{v.fabric}}</td>
                  <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Date">{{v.dateOrder|date: 'dd-MM-yyyy'}}</td>
                                    <td data-title="Unit_Price">{{v.priceSeller}}</td>
                                    <td data-title="Qty">{{v.qty}}</td>
                                    <td data-title="Total">{{v.total}}</td>
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!-- <td data-title="Qty">{{v.notes}}</td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
                  <td data-title="Price">{{v.price}}</td>
                  <td data-title="Supplier">{{v.suppliername}}</td>
                  <td data-title="PI NO">{{v.pino}}</td>
                  <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <!-- <td data-title="Photo" class='no'>
                      <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url.url'>
                  </td>
                  <td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                  <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
                  </td>
                  <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
                  </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>



<!-- !!!: Store Invoice -->

<div class="col-12 goStoreInvoice">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Store : {{nameStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Code : {{codeStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Description : {{descriptionStore}} </span>                <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Category : {{categoryStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; From Date : {{dateFromStore}} </span> <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To Date : {{dateToStore}} </span>                <span class='allQtyShow'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Qty : {{sumtotalStore}} </span> </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
    <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col">Item_Code</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Location</th>

                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <!-- <th scope="col">Dimensions</th>
      <th scope="col">Finishing/fabrics</th>
      <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                              <th scope="col">Out</th>
                              <th scope="col">Reseved</th>
                              <th scope="col">Available</th>
                              <th scope="col">Defect</th>
                              <th scope="col">Sales</th>
                              <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
      <th scope="col">Price</th>
      <th scope="col">Supplier</th>
      <th scope="col">PI.NO</th>
      <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
      <th scope="col" class='no' *ngIf='delete'>Delete</th>
      <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|serchCode:serchCodeStore|placeSearch:placeSearchStore|dateCom:dateFromStore:dateToStore; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Type" *ngIf='v.orderto == 1'>Order</td>
                                    <td data-title="Type" *ngIf='v.orderto == 0'>Store</td>
                                    <td data-title="Invoice_No">{{v.id_boked}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
    <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
      <td data-title="Finishing/fabrics">{{v.fabric}}</td>
      <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Item_Code">{{v.code}}</td>
                                    <td data-title="Name">{{v.customername}}</td>
                                    <td data-title="Location">{{v.placeName}}</td>
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                              <td data-title="Sales">{{v.sales}}</td>
                              <td data-title="Notes">
                                  <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                              </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
      <td data-title="Price">{{v.price}}</td>
      <td data-title="Supplier">{{v.suppliername}}</td>
      <td data-title="PI NO">{{v.pino}}</td>
      <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
      <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
      </td>
      <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
      </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: Sales Invoice Order -->

<div class="col-12 goSalesInvoice">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Quotation No : {{yarbs000}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Customer Name : {{nameCustomerSales}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> City : {{cityCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Adress : {{adreesCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Date : {{dateSales|date:'dd-MM-yyyy'}} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Total : {{sumtotalCustomer11223}} </span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <!-- <th scope="col">Type</th>
                                    <th scope="col">Invoice_No</th> -->
                                    <!-- <th scope="col">Order Date</th>
  <th scope="col">Shipping Date</th> -->
                                    <!-- <th scope="col">Date</th> -->
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Name</th>
                                    <th scope="col">Location</th> -->

                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">Total</th>
                                    <!-- <th scope="col">Dimensions</th>
    <th scope="col">Finishing/fabrics</th>
    <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                            <th scope="col">Out</th>
                            <th scope="col">Reseved</th>
                            <th scope="col">Available</th>
                            <th scope="col">Defect</th>
                            <th scope="col">Sales</th>
                            <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
    <th scope="col">Price</th>
    <th scope="col">Supplier</th>
    <th scope="col">PI.NO</th>
    <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
    <th scope="col" class='no' *ngIf='delete'>Delete</th>
    <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|quotationBill:yarbs000; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <!-- <td data-title="Type" *ngIf='v.orderto == 1'>Order</td>
                                  <td data-title="Type" *ngIf='v.orderto == 0'>Store</td>
                                  <td data-title="Invoice_No">{{v.id_boked}}</td> -->
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
  <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
    <td data-title="Finishing/fabrics">{{v.fabric}}</td>
    <td data-title="Category">{{v.categoryname}}</td> -->
                                    <!-- <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td> -->
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Name">{{v.customername}}</td>
                                  <td data-title="Location">{{v.placeName}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Quantity">{{v.qty}}</td>
                                    <td data-title="Unit Price">{{v.priceSeller}}</td>
                                    <td data-title="Total">{{v.total}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                            <td data-title="Sales">{{v.sales}}</td>
                            <td data-title="Notes">
                                <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                            </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
    <td data-title="Price">{{v.price}}</td>
    <td data-title="Supplier">{{v.suppliername}}</td>
    <td data-title="PI NO">{{v.pino}}</td>
    <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
    <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
    </td>
    <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: Sales Invoice Hold -->

<div class="col-12 goSalesInvoiceHold">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Quotation No : {{yarbs000All}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Customer Name : {{nameCustomerSales}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> City : {{cityCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Adress : {{adreesCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Date : {{dateSales|date:'dd-MM-yyyy'}} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Total : {{sumtotalCustomer11222}} </span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <!-- <th scope="col">Type</th>
                                  <th scope="col">Invoice_No</th> -->
                                    <!-- <th scope="col">Order Date</th>
<th scope="col">Shipping Date</th> -->
                                    <!-- <th scope="col">Date</th> -->
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Name</th>
                                  <th scope="col">Location</th> -->

                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">Total</th>
                                    <!-- <th scope="col">Dimensions</th>
  <th scope="col">Finishing/fabrics</th>
  <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                          <th scope="col">Out</th>
                          <th scope="col">Reseved</th>
                          <th scope="col">Available</th>
                          <th scope="col">Defect</th>
                          <th scope="col">Sales</th>
                          <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
  <th scope="col">Price</th>
  <th scope="col">Supplier</th>
  <th scope="col">PI.NO</th>
  <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
  <th scope="col" class='no' *ngIf='delete'>Delete</th>
  <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|quotationBill:yarbs000All; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <!-- <td data-title="Type" *ngIf='v.orderto == 1'>Order</td>
                                <td data-title="Type" *ngIf='v.orderto == 0'>Store</td>
                                <td data-title="Invoice_No">{{v.id_boked}}</td> -->
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
<td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
  <td data-title="Finishing/fabrics">{{v.fabric}}</td>
  <td data-title="Category">{{v.categoryname}}</td> -->
                                    <!-- <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td> -->
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Name">{{v.customername}}</td>
                                <td data-title="Location">{{v.placeName}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Quantity">{{v.qty}}</td>
                                    <td data-title="Unit Price">{{v.priceSeller}}</td>
                                    <td data-title="Total">{{v.total}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                          <td data-title="Sales">{{v.sales}}</td>
                          <td data-title="Notes">
                              <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                          </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
  <td data-title="Price">{{v.price}}</td>
  <td data-title="Supplier">{{v.suppliername}}</td>
  <td data-title="PI NO">{{v.pino}}</td>
  <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
  <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
  </td>
  <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
  </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: Sales Invoice All -->

<div class="col-12 goSalesAll00">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Quotation No : {{yarbs000All0}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Customer Name : {{nameCustomerSales}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> City : {{cityCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Adress : {{adreesCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span> Date : {{dateSales|date:'dd-MM-yyyy'}} </span><span> Adress : {{adreesCustomerSaled}} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> Total : {{sumtotalCustomer1122}} </span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <!-- <th scope="col">Type</th>
                                <th scope="col">Invoice_No</th> -->
                                    <!-- <th scope="col">Order Date</th>
<th scope="col">Shipping Date</th> -->
                                    <!-- <th scope="col">Date</th> -->
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Name</th>
                                <th scope="col">Location</th> -->

                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">Total</th>
                                    <!-- <th scope="col">Dimensions</th>
<th scope="col">Finishing/fabrics</th>
<th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                        <th scope="col">Out</th>
                        <th scope="col">Reseved</th>
                        <th scope="col">Available</th>
                        <th scope="col">Defect</th>
                        <th scope="col">Sales</th>
                        <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
<th scope="col">Price</th>
<th scope="col">Supplier</th>
<th scope="col">PI.NO</th>
<th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
<th scope="col" class='no' *ngIf='delete'>Delete</th>
<th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|quotationBill:yarbs000All0; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <!-- <td data-title="Type" *ngIf='v.orderto == 1'>Order</td>
                              <td data-title="Type" *ngIf='v.orderto == 0'>Store</td>
                              <td data-title="Invoice_No">{{v.id_boked}}</td> -->
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
<td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
<td data-title="Finishing/fabrics">{{v.fabric}}</td>
<td data-title="Category">{{v.categoryname}}</td> -->
                                    <!-- <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td> -->
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Name">{{v.customername}}</td>
                              <td data-title="Location">{{v.placeName}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Quantity">{{v.qty}}</td>
                                    <td data-title="Unit Price">{{v.priceSeller}}</td>
                                    <td data-title="Total">{{v.total}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                        <td data-title="Sales">{{v.sales}}</td>
                        <td data-title="Notes">
                            <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                        </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
<td data-title="Price">{{v.price}}</td>
<td data-title="Supplier">{{v.suppliername}}</td>
<td data-title="PI NO">{{v.pino}}</td>
<td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
<td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
</td>
<td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
</td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>

<!-- !!!: sales invoice Area -->

<div class="col-12 salesInvoice">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Area : {{yarbs000All0Sales}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='supplier3'> From Date : {{dateFrom}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier4'> To Date : {{dateTo}}  </span>
                <span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Amount : {{totalArea}} </span>
            </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
    <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Amount_After_Discount</th>
                                    <!-- <th scope="col">Dimensions</th>
      <th scope="col">Finishing/fabrics</th>
      <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                              <th scope="col">Out</th>
                              <th scope="col">Reseved</th>
                              <th scope="col">Available</th>
                              <th scope="col">Defect</th>
                              <th scope="col">Sales</th>
                              <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
      <th scope="col">Price</th>
      <th scope="col">Supplier</th>
      <th scope="col">PI.NO</th>
      <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
      <th scope="col" class='no' *ngIf='delete'>Delete</th>
      <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of areeAllSales|areaFilter:yarbs000All0Sales|dateComOrder:dateFrom:dateTo|orderOnly; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.id}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
    <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
      <td data-title="Finishing/fabrics">{{v.fabric}}</td>
      <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Date">{{v.dateorder|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Name">{{v.nameClient}}</td>
                                    <!-- <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td> -->
                                    <td data-title="Amount_After_Discount">{{v.totalprice - (v.totalprice * (v.discound / 100 ))}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                              <td data-title="Sales">{{v.sales}}</td>
                              <td data-title="Notes">
                                  <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                              </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
      <td data-title="Price">{{v.price}}</td>
      <td data-title="Supplier">{{v.suppliername}}</td>
      <td data-title="PI NO">{{v.pino}}</td>
      <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->

                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
      <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
      </td>
      <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
      </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: Sales Invoice Category -->

<div class="col-12 goSalesInvoiceCategory">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Category : {{categorySearch}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='supplier3'> From Date : {{dateFrom}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier4'> To Date : {{dateTo}}  </span><span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total Qty : {{sumtotalCustomer11}}</span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Invoice_No</th>
                                    <th scope="col">Date</th>
                                    <!-- <th scope="col">Type</th> -->

                                    <!-- <th scope="col">Order Date</th>
<th scope="col">Shipping Date</th> -->
                                    <!-- <th scope="col">Date</th> -->
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Name</th>
                                  <th scope="col">Location</th> -->

                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <!-- <th scope="col">Price</th> -->
                                    <!-- <th scope="col">Total</th> -->
                                    <!-- <th scope="col">Dimensions</th>
  <th scope="col">Finishing/fabrics</th>
  <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                          <th scope="col">Out</th>
                          <th scope="col">Reseved</th>
                          <th scope="col">Available</th>
                          <th scope="col">Defect</th>
                          <th scope="col">Sales</th>
                          <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
  <th scope="col">Price</th>
  <th scope="col">Supplier</th>
  <th scope="col">PI.NO</th>
  <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
  <th scope="col" class='no' *ngIf='delete'>Delete</th>
  <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|dateComOrder:dateFrom:dateTo|categorySearch:categorySearch|orderOnly; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.id_boked}}</td>
                                    <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                    <!-- <td data-title="Type" *ngIf='v.orderto == 1'>Order</td>
                                <td data-title="Type" *ngIf='v.orderto == 0'>Store</td>
                                 -->
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
<td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
  <td data-title="Finishing/fabrics">{{v.fabric}}</td>
  <td data-title="Category">{{v.categoryname}}</td> -->
                                    <!-- <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td> -->
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Name">{{v.customername}}</td>
                                <td data-title="Location">{{v.placeName}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Quantity">{{v.qty}}</td>
                                    <!-- <td data-title="Unit Price">{{v.priceSeller}}</td> -->
                                    <!-- <td data-title="Total">{{v.total}}</td> -->
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                          <td data-title="Sales">{{v.sales}}</td>
                          <td data-title="Notes">
                              <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                          </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
  <td data-title="Price">{{v.price}}</td>
  <td data-title="Supplier">{{v.suppliername}}</td>
  <td data-title="PI NO">{{v.pino}}</td>
  <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
  <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
  </td>
  <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
  </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: all sales invoice -->

<div class="col-12 salesInvoiceAll">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnSales()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2 px-5" style="text-align: right;"><span>Total Amount : {{totalArea1}} </span></h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
  <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Percentage_Discount</th>
                                    <th scope="col">Discount</th>
                                    <th scope="col">Amount_After_Discount</th>
                                    <!-- <th scope="col">Dimensions</th>
    <th scope="col">Finishing/fabrics</th>
    <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                            <th scope="col">Out</th>
                            <th scope="col">Reseved</th>
                            <th scope="col">Available</th>
                            <th scope="col">Defect</th>
                            <th scope="col">Sales</th>
                            <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
    <th scope="col">Price</th>
    <th scope="col">Supplier</th>
    <th scope="col">PI.NO</th>
    <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
    <th scope="col" class='no' *ngIf='delete'>Delete</th>
    <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of areeAllSales|dateComOrder:dateFrom:dateTo|orderOnly; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.id}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
  <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
    <td data-title="Finishing/fabrics">{{v.fabric}}</td>
    <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Date">{{v.dateorder|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Name">{{v.nameClient}}</td>
                                    <td data-title="Amount">{{v.totalprice}}</td>
                                    <td data-title="Percentage_Discount">{{v.discound}}</td>
                                    <td data-title="Discount">{{v.totalprice * ( v.discound / 100 ) }}</td>
                                    <!-- <td data-title="Description">
                                      <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                  </td> -->
                                    <td data-title="Amount_After_Discount">{{ v.totalprice - (v.totalprice *(v.discound / 100 ))}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                            <td data-title="Sales">{{v.sales}}</td>
                            <td data-title="Notes">
                                <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                            </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
    <td data-title="Price">{{v.price}}</td>
    <td data-title="Supplier">{{v.suppliername}}</td>
    <td data-title="PI NO">{{v.pino}}</td>
    <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->

                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
    <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
    </td>
    <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>



<!-- !!!: Admin Table invoice -->

<div class="col-12 goSupplierinvoiceAdmin">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printSupplier()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnNewAdmin()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Company : {{nameSubPri1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='supplier3'> From Date : {{dateFromSuAdmin}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier4'> To Date : {{dateToSuAdmin}}  </span>
                <span class='country'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Country : {{searchsupplierCountry1}} </span>
            </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Invoice_No</th>
                                    <!-- <th scope="col">Order Date</th>
      <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Date</th>
                                    <th scope="col">Item_Code</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Unit_Price</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Total_Price</th>
                                    <!-- <th scope="col">Dimensions</th>
        <th scope="col">Finishing/fabrics</th>
        <th scope="col">Category</th> -->
                                    <!-- <th scope="col">In</th>
                                <th scope="col">Out</th>
                                <th scope="col">Reseved</th>
                                <th scope="col">Available</th>
                                <th scope="col">Defect</th>
                                <th scope="col">Sales</th>
                                <th scope="col">Notes</th> -->
                                    <!-- <th scope="col">Branch</th>
        <th scope="col">Price</th>
        <th scope="col">Supplier</th>
        <th scope="col">PI.NO</th>
        <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
        <th scope="col" class='no' *ngIf='delete'>Delete</th>
        <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreReportCustomer|searchSupplier:searchsupplierAdmin1|selectpin:selectpinAdmin1|dateCom:dateFromSuAdmin:dateToSuAdmin|orderOnly|countrySearch1:searchsupplierCountry1; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Invoice_No">{{v.id_boked}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
      <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
        <td data-title="Finishing/fabrics">{{v.fabric}}</td>
        <td data-title="Category">{{v.categoryname}}</td> -->
                                    <td data-title="Date">{{v.date|date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Item_Code">{{v.code}}</td>
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <td data-title="Unit_Price">{{v.priceSeller}}</td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <td data-title="Total_Price">{{v.total}}</td>
                                    <!-- <td data-title="Defect">{{v.defect}}</td>
                                <td data-title="Sales">{{v.sales}}</td>
                                <td data-title="Notes">
                                    <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>

                                </td> -->
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
        <td data-title="Price">{{v.price}}</td>
        <td data-title="Supplier">{{v.suppliername}}</td>
        <td data-title="PI NO">{{v.pino}}</td>
        <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!--<td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
        <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
        </td>
        <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
        </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>


<!-- !!!: Admin Store Table -->


<div class="col-12 goStoreAdmin">
    <div class="card" style='margin-bottom: 0 !important;'>
        <div class="card-header" style='padding: 0;'>
            <div class="container-fluid printch" style="padding: 0 !important;padding-left: 10px !important;padding-right: 10px !important;">
                <div class="row">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='printStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button>
                    </div>
                    <div class="col-lg-2 col-12 lastU mt-1">
                        <!-- <label>Print : </label><br> -->
                        <button (click)='returnStore()' class="p-1 mb-2 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-undo"></i></button>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
            </div>
            <h2 class="supplierto mt-2 mb-2" style="text-align: center;"><span>Company : {{nameSubPri1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class='supplier3'> From Date : {{dateFromSuAdmin}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span> <span class='supplier4'> To Date : {{dateToSuAdmin}}  </span>
                <span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Country : {{searchsupplierCountry1}} </span><span class='supplier4'> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total : {{sumSales009}} </span>
            </h2>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 69vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;padding-right: 0 !important;padding-left: 0 !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No</th>
                                    <th scope="col">Code</th>
                                    <!-- <th scope="col">Order Date</th>
            <th scope="col">Shipping Date</th> -->
                                    <th scope="col">Description</th>
                                    <!-- <th scope="col">Dimensions</th>
              <th scope="col">Finishing/fabrics</th>
               -->

                                    <th scope="col">Unit_Price</th>
                                    <!-- <th scope="col">Reseved</th> -->
                                    <th scope="col">Qty</th>
                                    <th scope="col">Store</th>
                                    <th scope="col">Total_price</th>

                                    <!-- <th scope="col">Branch</th>
              <th scope="col">Price</th>
              <th scope="col">Supplier</th>
              <th scope="col">PI.NO</th>
              <th scope="col">Sales</th> -->
                                    <!-- <th scope="col">User</th> -->
                                    <th scope="col" class='no'>Photo</th>
                                    <!-- <th scope="col" class='no' *ngIf='update'>Update</th>
              <th scope="col" class='no' *ngIf='delete'>Delete</th>
              <th scope="col" class='no'>Barcode</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arreStore|searchSupplier:searchsupplierAdmin1|dateCom:dateFromSuAdmin:dateToSuAdmin|selectpin:selectpinAdmin1|countrySearch:searchsupplierCountry1; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Code">{{v.code}}</td>
                                    <!-- <td data-title="Order Date">{{v.dateorder}}</td>
            <td data-title="Shipping Date">{{v.datereceipt}}</td> -->
                                    <td data-title="Description">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                                    </td>
                                    <!-- <td data-title="Dimensions">{{v.dimensions}}</td>
              <td data-title="Finishing/fabrics">{{v.fabric}}</td>
              </td> -->

                                    <td data-title="Unit_Price">{{v.price}}</td>
                                    <!-- <td data-title="Reseved">{{v.mainqty - (v.qty + v.qtyfinish)}}</td> -->
                                    <td data-title="Qty">{{v.qty}}</td>
                                    <td data-title="Store">{{v.rootname}}</td>
                                    <td data-title="Total_price">{{v.qty * v.price}}</td>
                                    <!-- <td data-title="Branch">{{v.rootname}}</td>
              <td data-title="Price">{{v.price}}</td>
              <td data-title="Supplier">{{v.suppliername}}</td>
              <td data-title="PI NO">{{v.pino}}</td>
              <td data-title="Sales">{{v.sales}}</td> -->
                                    <!-- <td data-title="Password" >{{v.username}}</td> -->
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.url'>
                                    </td>
                                    <!-- <td data-title="Update" class='no'><button (click)='upI(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
              <td data-title="Delete" class='no'><button (click)='delI(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
              </td>
              <td data-title="Barcode" class='no'><button (click)='barcode(v)' type="button" class="btn btn-dark" style="box-shadow: none; background-color: black;"><i class="fas fa-barcode"></i></button>
              </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</div>